import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-system-prototype',
});

export const systemPrototypeDetailRouteRef = createSubRouteRef({
  id: 'system-prototype-detail',
  parent: rootRouteRef,
  path: '/:id',
});
